import api from '@motionelements/core/src/api/base-api-v2';

const mainUrl = '/v2/artists';

/**
 * get artists profile
 * @param {String} username
 */
// eslint-disable-next-line import/prefer-default-export
export const getArtist = async (username) => {
  const response = await api.get(`${mainUrl}/${username}`, {
    params: api.getLocaleParams(),
  });
  return response;
};

export const followArtist = (username) => api.request('put', `${mainUrl}/${username}/follow`);
export const unFollowArtist = (username) => api.request('delete', `${mainUrl}/${username}/follow`);
